export const whiteSpaceNotAllowedFirstLetter = value => value && /^\S.*/.test(value) ? undefined : 'first letter can not be space';
export const required = value => value ? undefined : 'is required'